import(/* webpackMode: "eager", webpackExports: ["NpbTeamListClient"] */ "/Users/yk/Dev/BaseballDataViewer/nextjs/components/client/HomeClient.tsx");
